<template>
    <div>
        <a-row type="flex" style="margin-bottom: 12px;margin-top: 12px">
            <a-col>
                <strong style="font-size: 25px">Bimbingan {{ title }}</strong>
            </a-col>
        </a-row>       
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
        },
    }
</script>